// extracted by mini-css-extract-plugin
export default {"ClientLogo":"styles_ClientLogo__hv4ua","Container":"styles_Container__L3u5X"};